// src/contexts/PaymentContext.js
import React, { createContext, useContext, useState } from 'react';

const PaymentContext = createContext();

export const usePayment = () => useContext(PaymentContext);

export const PaymentProvider = ({ children }) => {
  const [paymentStatus, setPaymentStatus] = useState({
    isPaid: false,
    credits: 0,
    session_id: null,
  });

  const updatePaymentStatus = (status) => {
    setPaymentStatus((prev) => ({ ...prev, ...status }));
  };

  return (
    <PaymentContext.Provider value={{ paymentStatus, updatePaymentStatus }}>
      {children}
    </PaymentContext.Provider>
  );
};
